interface LogoProps {
  variant?: "default" | "white" | "compact" | "benchmark" | "original" | "whitebg";
  className?: string;
  imgClassName?: string;
  showText?: boolean;
}

export function Logo({
  variant = "default",
  className = "",
  imgClassName = "h-8 w-auto object-contain",
  showText = false,
}: LogoProps) {
  if (variant === "compact" || variant === "benchmark") {
    return (
      <div className={`inline-flex items-center select-none ${className}`}>
        {/* Benchmark logo light mode */}
        <img
          src="/logo/soorgaa_benchmark1.png"
          alt="Soorgaa"
          className="w-8 h-8 object-contain shrink-0 dark:hidden"
        />
        {/* Benchmark logo dark mode */}
        <img
          src="/logo/soorgaa White and Orange bench mark.png"
          alt="Soorgaa"
          className="w-8 h-8 object-contain shrink-0 hidden dark:block"
        />
      </div>
    );
  }

  if (variant === "white") {
    return (
      <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
        <img
          src="/logo/soorgaa_logo_white.png"
          alt="Soorgaa"
          className={imgClassName}
        />
        {showText && (
          <span className="font-display font-bold text-lg tracking-tight text-white">
            Soorgaa
          </span>
        )}
      </div>
    );
  }

  if (variant === "original") {
    return (
      <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
        <img
          src="/logo/soorgaa_logo_original.png"
          alt="Soorgaa"
          className={imgClassName}
        />
        {showText && (
          <span className="font-display font-bold text-lg tracking-tight text-foreground">
            Soorgaa
          </span>
        )}
      </div>
    );
  }

  if (variant === "whitebg") {
    return (
      <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
        <img
          src="/logo/soorgaa_logo_whitebg.jpg"
          alt="Soorgaa"
          className={imgClassName}
        />
        {showText && (
          <span className="font-display font-bold text-lg tracking-tight text-foreground">
            Soorgaa
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`}>
      {/* Light mode: crisp black text with vibrant orange mark */}
      <img
        src="/logo/soorgaa_logo.png"
        alt="Soorgaa"
        className={`${imgClassName} dark:hidden`}
      />
      {/* Dark mode: crisp white text with vibrant orange mark */}
      <img
        src="/logo/soorgaa_logo_white.png"
        alt="Soorgaa"
        className={`${imgClassName} hidden dark:block`}
      />
      {showText && (
        <span className="font-display font-bold text-lg tracking-tight text-foreground">
          Soorgaa
        </span>
      )}
    </div>
  );
}
